<template>
  <div class="hide-on-print">
		<!-- Page Title -->
		<page-title
			icon="ni ni-chart-bar-32"
			main="Módulo de Crédito"
			sub="Aprovações"
		>
    </page-title>

		<!-- Filter -->
		<card v-if="filters">
			<div slot="header" class="row align-items-center">
				<div class="col">
					<h5 class="h3 mb-0">Pesquisar Cliente</h5>
				</div>
			</div>
			<div class="row">
				<div class="col-5">
					<label class="form-control-label">Nome do Cliente</label>
					<multiselect
            v-model="filter.client"
            :options="clients || []"
            :loading="!clients"
						placeholder="Cliente"
						label="name"
						:select-label="''"
						:deselect-label="''"
						:selected-label="'Selecionado'"
						track-by="code"
					></multiselect>
				</div>
        <div class="col-3">
					<label class="form-control-label">Autor</label>
					<multiselect
            v-model="filter.author"
            :options="authors || []"
            :loading="!authors"
						placeholder="Autor"
						:select-label="''"
						:deselect-label="''"
						:selected-label="'Selecionado'"
						track-by="code"
					></multiselect>
				</div>
        <div class="col-md-4">
          <div style="margin-top: 2rem">
            <base-button icon @click="filterProposal" type="purple" style="width: 300px;">
              <span class="btn-inner--text text-white">Pesquisar</span>
            </base-button>
          </div>
        </div>
			</div>
		</card>
    <card>
      <proposal @on:changed='getProposals()' :responsibleId="this.$currentUser.id" :clients="clients" :approval="true" :notEdit="true" :proposals="proposals || []" :loadProposals="!proposals" />
    </card>
	</div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle"
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import Proposal from './components/Proposal.vue'

export default {
  name: 'proposal-cri',
  components: { 
    PageTitle, 
    Proposal,
    Multiselect
  },
  data() {
    return {
      clients: null,
      client: {},
      filters: true,
      filter: {},
      proposals: null,
      authors: null
    }
  },
  mounted() {
    this.getProposals()
    this.getClientsCri()
  },
  methods: {
    filterProposal () {
      const client_id = this.filter.client ? this.filter.client.id : ''
      const created_at = this.filter.created_at ? this.filter.created_at : ''
      this.getProposals(created_at, client_id)
    },
    formatDate(dateString) {
      let dateParts = dateString.split(" / ")
      const finalString = '' + dateParts[1] + '-' + dateParts[0]
      if (dateParts.length > 2) finalString += '-' + dateParts[2]
      return finalString
    },
    async getClientsCri () {
      const response = await this.$http.secured.get("/api/v1/credit_analysis/get_clients")
      this.clients = response.data
    },
    async getProposals (created_at=null, client_id=null) {
      const data = {
        client_id: client_id,
        created_at: created_at,
        query: { responsible_id: this.$currentUser().id}
      }
      const response = await this.$http.secured.get("/api/v1/credit_analysis/get_proposals", { params: data })
      this.proposals = response.data
      this.authors = this.proposals.map(proposal => proposal.author)
      this.authors = [...new Set(this.authors)]
      this.proposals.map(proposal => proposal.validity_date = new Date(`${proposal.validity_date}T00:00`))
    },
  }
}
</script>
